import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import PromptModal from "../prompt-modal";
import IsInvertedProvider from "../is-inverted-provider";
import { promptTypes } from "../../../enums";
var DiscardChangesModal = createComponent({
  displayName: 'DiscardChangesModal',
  propTypes: {
    isOpen: PropTypes.bool.isRequired,
    isSaveDisabled: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onDiscard: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  },
  defaultProps: {
    isSaveDisabled: false
  },
  render: function render(p) {
    return /*#__PURE__*/React.createElement(IsInvertedProvider, {
      isInverted: true
    }, /*#__PURE__*/React.createElement(PromptModal, {
      header: "You have unsaved changes",
      byline: "You can save or discard your changes, or click Cancel to return to the edit screen.",
      promptType: promptTypes.WARNING,
      isOpen: p.isOpen,
      acknowledgeAction: {
        onClick: p.onDiscard,
        text: 'Discard Changes'
      },
      otherAction: {
        onClick: p.onSave,
        isDisabled: p.isSaveDisabled,
        text: 'Save & Close'
      },
      cancelAction: {
        onClick: p.onCancel,
        text: 'Cancel'
      }
    }));
  }
});
export default DiscardChangesModal;
//# sourceMappingURL=index.js.map